// eslint-disable-next-line
export const MEDIA_MOBILE_MAX_WIDTH = '1200px';
